import { Component, OnInit } from '@angular/core';
import {ProductsService} from "../../../../../../services/products/products.service";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Product} from "../../../../../../models/Product";
import {PrixService} from "../../../../../../main/parametre/liste-prix/prix.service";

@Component({
  selector: 'app-tarif',
  templateUrl: './tarif.component.html',
  styleUrls: ['./tarif.component.scss']
})
export class TarifComponent implements OnInit {

    productId!: number;
    productData: any = {};
    prixLibelle: string = '—';
    stationId!: number;

  constructor(private productsService : ProductsService,
              private route: ActivatedRoute,
              private toastr: ToastrService,
              private prixService: PrixService) {
      this.loadUserData();
  }

  ngOnInit(): void {
      this.productId = +this.route.parent?.snapshot.paramMap.get('id')!;
      this.getProduct();
  }

    getProduct(): void {
        this.productsService.getDetailsProduct(this.productId).subscribe({
            next: (response: Product) => {
                this.productData = response;
                // Load prix libelle if prix_id exists
                if (this.productData.liste_prix?.[0]?.prix_id && this.stationId) {
                    this.loadPrixLibelle(this.productData.liste_prix[0].prix_id);
                }
                // console.log(this.productData);
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement du produit');
            }
        });
    }

    private loadUserData(): void {
        try {
            const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
            this.stationId = user?.stations?.[0]?.id || 0;
        } catch (error) {
            console.error('Error parsing currentUser from localStorage:', error);
            this.stationId = 0;
        }
    }

    private loadPrixLibelle(prixId: number): void {
        if (!this.stationId || !prixId) {
            this.prixLibelle = '—';
            return;
        }
        this.prixService.getPrixById(this.stationId, prixId).subscribe({
            next: (prix) => {
                this.prixLibelle = prix.libelle || '—';
            },
            error: (err) => {
                console.error('Error loading prix libelle:', err);
                this.prixLibelle = '—';
            }
        });
    }

    getTaxesNames(): string {
        if (!this.productData.taxes || !Array.isArray(this.productData.taxes) || this.productData.taxes.length === 0) {
            return '--';
        }
        return this.productData.taxes
            .map((taxe: any) => taxe.nom)
            .filter((nom: string) => nom) // Filter out null/undefined/empty names
            .join(', ');
    }

}
